<template>
  <div class="results">
    <ahc-filter
      v-if="!isPast"
      :filterData="filterData"
      @filterUpdate="handleFilter"
      @filterReset="handleReset"
    ></ahc-filter>

    <slot name="callout" :showFeatured="showFeatured"></slot>
    <slot name="blocklist" v-if="showingFirstResults"></slot>
    <div v-else>
      <div class="block-list">
        <ul class="block-list__items block-list__items--4-up">
          <li
            class="block-list__item"
            v-for="(result, idx) in results"
            :key="`result-${idx}`"
          >
            <ahc-block-list-card :card-data="result"> </ahc-block-list-card>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script lang="js">
import ahcFilter from "../filter/filter.vue";
import ahcBlockListCard from "../block-list/block-list-card.vue";

export default {
  name: 'ahc-results',
  components: {
    ahcFilter,
    ahcBlockListCard,
  },
  props: {
    filterData: {
      type: Object,
      required: true,
    },
    allResults: {
      type: Array,
      required: true,
    },
    isPast: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      results: [],
      showingFirstResults: true,
      showFeatured: true,
    }
  },
  mounted() {

  },
  methods: {
    handleFilter(filterSelections) {
      let filteredResults = [];

      // loop over all results
      if (this.filtersSet(filterSelections)) {
        this.$nextTick(() => {
          // if filters are set, hide featured callout
          this.showFeatured = false;
          this.allResults.forEach((result) => {

            // loop over the selections (types, topics, virtual)
            if (Object.keys(filterSelections).every((selection) => {
              let match;

              if (filterSelections[selection] !== '' && filterSelections[selection] !== null) {
                if (selection === 'Virtual Event') {
                  if (filterSelections[selection]) {
                    match = result.meta[selection] === true && result.meta[selection] === filterSelections[selection];
                  } else {
                    match = true;
                  }
                } else {
                  match = result.meta[selection].indexOf(filterSelections[selection]) !== -1;
                }
                return match;
              } else {
                return true;
              }
            })) {
              filteredResults.push(result);
            }
          });

          this.showingFirstResults = false;
          this.results = filteredResults;
        });
      } else {
        this.showFeatured = true;
        this.results = this.allResults;
      }
    },
    /**
     * Determine if there are filters specified. The object has
     * keys for every individual filter term, so it has to be
     * looped over to determine if any arrays are empty.
     * @param {object} filterSelections
     */
    filtersSet(filterSelections) {
      let matches = [];
      Object.keys(filterSelections).forEach(filter => {
        if (filterSelections[filter] !== null && filterSelections[filter]) {
          matches.push(filterSelections[filter]);
        }
      });
      return matches.length > 0;
    },
    handleReset() {
      this.showFeatured = true;
      this.results = this.allResults;
    }
  },
}
</script>
